







import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component({})
export default class ExclamationIcon extends Vue {
  @Prop({ required: true })
  readonly backgroundColor: string

  @Prop({ required: true })
  readonly strokeColor: string

  @Prop({ required: false, default: 16 })
  readonly width: number

  @Prop({ required: false, default: 16 })
  readonly height: number
}
